import styled from "styled-components";

export const BrandImageStyledContainer = styled.div`
   width: ${({ width }) => width ? width : "17.376rem"};
   height: 3.6rem;
   cursor: pointer;
`;

export const BrandImageStyledComponent = styled.img`
   width: 100%;
   height: 100%;
   object-fit: contain;
`;
